import React from 'react';
import { Plus, Search } from 'lucide-react';
import { AppSelectDropdown } from '../../AppSelectDropdown';
import {
  PAYROLL_ADJUSTMENT_FILTER_DROPDOWN_CLASS,
  PAYROLL_ADJUSTMENT_TOOLBAR_CONTROL_CLASS,
  PAYROLL_ADJUSTMENT_TYPE_FILTER_OPTIONS,
} from './payrollAdjustmentListShared';

type PayrollAdjustmentBookingsToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  typeFilter: string;
  onTypeFilterChange: (value: string) => void;
  onAdd?: () => void;
  trailing?: React.ReactNode;
  endTrailing?: React.ReactNode;
  searchFullWidth?: boolean;
  showAddButton?: boolean;
  typeFilterOptions?: ReadonlyArray<{ value: string; label: string }>;
};

export function PayrollAdjustmentBookingsToolbar({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  typeFilterOptions = PAYROLL_ADJUSTMENT_TYPE_FILTER_OPTIONS,
  onAdd,
  trailing,
  endTrailing,
  searchFullWidth = false,
  showAddButton = true,
}: PayrollAdjustmentBookingsToolbarProps) {
  return (
    <div className="flex items-center gap-2">
      <div
        className={`relative min-w-0 ${searchFullWidth ? 'flex-1' : 'w-[490px] max-w-full shrink-0'}`}
      >
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-app-text-subtle" />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Suchen…"
          className={`w-full ${PAYROLL_ADJUSTMENT_TOOLBAR_CONTROL_CLASS} rounded-md border border-app-border bg-app-surface py-0 pl-9 pr-3 text-sm`}
        />
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-2">
        {trailing}
        <AppSelectDropdown
          value={typeFilter}
          onChange={onTypeFilterChange}
          options={[...typeFilterOptions]}
          triggerClassName={PAYROLL_ADJUSTMENT_FILTER_DROPDOWN_CLASS}
          className="min-w-[170px] [&>button]:h-9 [&>button]:rounded-md [&>button]:py-0"
        />
        {endTrailing}
        {showAddButton && onAdd ? (
          <button
            type="button"
            onClick={onAdd}
            className={`inline-flex ${PAYROLL_ADJUSTMENT_TOOLBAR_CONTROL_CLASS} items-center gap-1.5 rounded-md bg-emerald-500 px-3.5 py-0 text-sm font-semibold text-white hover:bg-emerald-600`}
          >
            <Plus className="h-4 w-4" />
            Neue Buchung
          </button>
        ) : null}
      </div>
    </div>
  );
}
